import { Card, Row, Col, Button, Form } from 'react-bootstrap';
import { Formik } from 'formik';
import ValidationInput from './ValidationTextInput';
import EditAddress from './EditAddress';
import TitleCard from './TitleCard';
import formatPhoneNumber from '../services/formatPhoneNumber';
import * as yup from 'yup';
import {
  stringValidation,
  companyNameValidation,
  cityValidation,
  zipValidation,
  emailValidation,
  phoneValidation,
} from '../services/validation';

const EditCompanyForm = ({
  onSubmit,
  initialValues,
  setEditing,
  onCancel,
  onDelete,
  index = 0,
  aLabel = '',
}) => {
  const companyInfoSchema = yup.object().shape({
    name: companyNameValidation(),
    address: stringValidation(),
    city: cityValidation(),
    state: stringValidation(),
    zip: zipValidation(),
    email: emailValidation(),
    phone: phoneValidation(),
  });

  return (
    <Card aria-label={aLabel} className="mb-3 edit-company-form">
      <Formik
        onSubmit={(values) => {
          onSubmit(values);
          setEditing(false);
        }}
        initialValues={initialValues}
        validationSchema={companyInfoSchema}
      >
        {({ setFieldValue, handleSubmit }) => (
          <Form onSubmit={handleSubmit} aria-label="edit-company-form">
            <Card.Header className="d-flex justify-content-between align-items-center">
              <Row className="w-100">
                <Col xs={7} md={6} lg={7}>
                  <Card.Title className="d-flex edit-company-name">
                    <h5>Company Name</h5>
                    <ValidationInput
                      placeholder="Company Name"
                      label=""
                      name="name"
                      aria-label="company-name-input"
                    />
                  </Card.Title>
                </Col>
                <Col className="d-flex justify-content-end">
                  <Button
                    aria-label="cancel-edit-button"
                    variant="danger"
                    onClick={() => {
                      setEditing(false);
                      onCancel();
                    }}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col xs={12} md={4}>
                  <TitleCard title="Address" cName="address-edit" headerFontSize="1.4rem">
                    <EditAddress />
                  </TitleCard>
                </Col>
                <Col xs={12} md={4}>
                  <TitleCard title="Email" cName="email-edit" headerFontSize="1.4rem">
                    <ValidationInput
                      label=""
                      type="email"
                      name="email"
                      placeholder="Email"
                      aria-label="company-email-input"
                    />
                  </TitleCard>
                </Col>
                <Col xs={12} md={4}>
                  <TitleCard title="Phone" cName="phone-edit" headerFontSize="1.4rem">
                    <ValidationInput
                      onChange={(value) => setFieldValue('phone', formatPhoneNumber(value))}
                      type="tel"
                      name="phone"
                      label=""
                      placeholder="Phone Number"
                      aria-label="company-phone-input"
                    />
                  </TitleCard>
                </Col>
              </Row>
              <Button className="dark-btn mt-3" type="submit" aria-label="save-company-info">
                Save
              </Button>
              {onDelete != null && (
                <Button
                  variant="danger"
                  className="mx-2"
                  onClick={() => {
                    setEditing(false);
                    onDelete(index);
                  }}
                >
                  Delete
                </Button>
              )}
            </Card.Body>
          </Form>
        )}
      </Formik>
    </Card>
  );
};

export default EditCompanyForm;
